
(function () {
  'use strict';

  // ── Nav scroll effect ──────────────────────────────────────
  const navbar = document.querySelector('.nav');
  if (navbar) {
    window.addEventListener('scroll', function () {
      navbar.classList.toggle('scrolled', window.scrollY > 20);
    }, { passive: true });
  }

  // ── Hamburger menu ─────────────────────────────────────────
  const hamburger = document.querySelector('[data-mobile-toggle]');
  const mobileMenu = document.querySelector('[data-mobile-menu]');
  if (hamburger && mobileMenu) {
    hamburger.addEventListener('click', function () {
      const isOpen = mobileMenu.classList.toggle('open');
      hamburger.setAttribute('aria-expanded', String(isOpen));
      hamburger.setAttribute('aria-label', isOpen ? 'Menü schließen' : 'Menü öffnen');
    });
    mobileMenu.querySelectorAll('a').forEach(function (link) {
      link.addEventListener('click', function () {
        mobileMenu.classList.remove('open');
        hamburger.setAttribute('aria-expanded', 'false');
      });
    });
  }

  // ── Product carousel ────────────────────────────────────────
  const slides = document.querySelectorAll('.product-slide');
  const dots = document.querySelectorAll('.dot');
  let current = 0;
  let carouselTimer = null;

  function goTo(index) {
    if (!slides.length || slides.length !== dots.length) return;
    slides[current].classList.remove('active');
    dots[current].classList.remove('active');
    dots[current].setAttribute('aria-selected', 'false');
    current = (index + slides.length) % slides.length;
    slides[current].classList.add('active');
    dots[current].classList.add('active');
    dots[current].setAttribute('aria-selected', 'true');
  }

  function startCarousel() {
    carouselTimer = setInterval(function () { goTo(current + 1); }, 3000);
  }

  dots.forEach(function (dot, i) {
    dot.addEventListener('click', function () {
      clearInterval(carouselTimer);
      goTo(i);
      startCarousel();
    });
    dot.addEventListener('keydown', function (e) {
      if (e.key === 'Enter' || e.key === ' ') {
        e.preventDefault();
        dot.click();
      }
    });
  });

  // Only pages with the product carousel have slides; without the guards
  // goTo() threw every 3 seconds on all other pages.
  if (slides.length > 1) startCarousel();

  // ── Scroll reveal via IntersectionObserver ─────────────────
  // Opt-in via html.js-reveal-ready (siehe theme.css). Wenn JS bricht,
  // bleiben alle Sektionen sichtbar (kein Default-opacity-0 mehr).
  var revealEls = document.querySelectorAll('.scroll-reveal');
  if ('IntersectionObserver' in window) {
    document.documentElement.classList.add('js-reveal-ready');
    var revealObserver = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('visible');
          revealObserver.unobserve(entry.target);
        }
      });
    }, { threshold: 0.12 });
    revealEls.forEach(function (el) {
      // Elemente, die bereits im Viewport sind, sofort sichtbar machen
      var r = el.getBoundingClientRect();
      if (r.top < window.innerHeight) {
        el.classList.add('visible');
      } else {
        revealObserver.observe(el);
      }
    });
  } else {
    revealEls.forEach(function (el) { el.classList.add('visible'); });
  }

  // ── Hero parallax on mousemove ─────────────────────────────
  var heroRight = document.getElementById('heroRight');
  var prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  if (!prefersReducedMotion && heroRight) {
    document.addEventListener('mousemove', function (e) {
      var xPct = (e.clientX / window.innerWidth - 0.5) * 2;
      var yPct = (e.clientY / window.innerHeight - 0.5) * 2;
      var wrap = heroRight.querySelector('.product-svg-wrap:not([style*="display:none"])') ||
                 heroRight.querySelector('.product-slide.active .product-svg-wrap');
      if (wrap) {
        wrap.style.transform = 'translateX(' + (xPct * 12) + 'px) translateY(' + (yPct * 8 + Math.sin(Date.now() / 1000) * 18) + 'px)';
      }
    }, { passive: true });
  }

  // ── Chat widget ────────────────────────────────────────────
  var chatBtn = document.getElementById('chatBtn');
  var chatWindow = document.getElementById('chatWindow');
  if (chatBtn && chatWindow) {
    chatBtn.addEventListener('click', function () {
      var isOpen = chatWindow.classList.toggle('open');
      chatBtn.setAttribute('aria-expanded', String(isOpen));
      chatBtn.setAttribute('aria-label', isOpen ? 'GNG Assistent schließen' : 'GNG Assistent öffnen');
    });
    chatWindow.querySelectorAll('.chat-quick-btn').forEach(function (btn) {
      btn.addEventListener('click', function () {
        alert('Anfrage wird weitergeleitet: ' + btn.textContent.trim());
      });
    });
  }

  // ── Social proof toasts ────────────────────────────────────
  var toastData = [
    { name: 'Ahmad aus Berlin', action: 'hat gerade Elfbar bestellt', initial: 'A' },
    { name: 'Mehmet aus Hamburg', action: 'hat Snickers Karton bestellt', initial: 'M' },
    { name: 'Sven aus München', action: 'hat Haribo Sortiment angefragt', initial: 'S' },
    { name: 'Fatima aus Köln', action: 'hat sich als Händler registriert', initial: 'F' },
    { name: 'Kevin aus Frankfurt', action: 'hat Flerbar Box bestellt', initial: 'K' },
  ];
  var toastEl = document.getElementById('toast');
  var toastName = document.getElementById('toastName');
  var toastAction = document.getElementById('toastAction');
  var toastInitial = document.getElementById('toastInitial');
  var toastIndex = 0;

  function showToast() {
    if (!toastEl || !toastName || !toastAction || !toastInitial) return;
    var data = toastData[toastIndex % toastData.length];
    toastName.textContent = data.name;
    toastAction.textContent = data.action;
    toastInitial.textContent = data.initial;
    toastEl.style.opacity = '1';
    toastEl.style.pointerEvents = 'auto';
    toastEl.classList.remove('hide');
    toastEl.classList.add('show');
    toastIndex++;

    setTimeout(function () {
      toastEl.classList.remove('show');
      toastEl.classList.add('hide');
      setTimeout(function () {
        toastEl.style.opacity = '0';
        toastEl.style.pointerEvents = 'none';
        toastEl.classList.remove('hide');
      }, 400);
    }, 4000);
  }

  if (toastEl) {
    setTimeout(function () {
      showToast();
      setInterval(showToast, 10000);
    }, 3000);
  }

  // ── Keyboard: close mobile menu on Escape ──────────────────
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') {
      if (mobileMenu && mobileMenu.classList.contains('open')) {
        mobileMenu.classList.remove('open');
        if (hamburger) {
          hamburger.setAttribute('aria-expanded', 'false');
          hamburger.focus();
        }
      }
      if (chatWindow && chatWindow.classList.contains('open')) {
        chatWindow.classList.remove('open');
        if (chatBtn) {
          chatBtn.setAttribute('aria-expanded', 'false');
          chatBtn.focus();
        }
      }
    }
  });

})();

// ── Command Palette + Merkliste ────────────────────────────────
(function () {
  'use strict';

  // ── Product database ────────────────────────────────────────
  var PRODUCTS = [
    { id:1,  name:'Snickers Original 48er',     brand:'Mars',     cat:'Süßwaren', unit:'48er Karton',  icon:'🍫' },
    { id:2,  name:'Snickers King Size 24er',     brand:'Mars',     cat:'Süßwaren', unit:'24er Karton',  icon:'🍫' },
    { id:3,  name:'Twix Original 32er',           brand:'Mars',     cat:'Süßwaren', unit:'32er Karton',  icon:'🍫' },
    { id:4,  name:'Bounty Duo 24er',              brand:'Mars',     cat:'Süßwaren', unit:'24er Karton',  icon:'🍫' },
    { id:5,  name:'Mars Bar 32er',                brand:'Mars',     cat:'Süßwaren', unit:'32er Karton',  icon:'🍫' },
    { id:6,  name:'Kit Kat 4-Finger 24er',        brand:'Nestlé',   cat:'Süßwaren', unit:'24er Karton',  icon:'🍫' },
    { id:7,  name:'Haribo Goldbären 175g',        brand:'Haribo',   cat:'Süßwaren', unit:'40er Karton',  icon:'🐻' },
    { id:8,  name:'Haribo Tangfastics 160g',      brand:'Haribo',   cat:'Süßwaren', unit:'40er Karton',  icon:'🐻' },
    { id:9,  name:'Haribo Starmix 175g',          brand:'Haribo',   cat:'Süßwaren', unit:'40er Karton',  icon:'🐻' },
    { id:10, name:'Mentos Rolle Classic',         brand:'Mentos',   cat:'Süßwaren', unit:'40er Display', icon:'🍬' },
    { id:11, name:'Mentos Fresh Mint',            brand:'Mentos',   cat:'Süßwaren', unit:'40er Display', icon:'🍬' },
    { id:12, name:'M&Ms Peanut 45g',             brand:'Mars',     cat:'Süßwaren', unit:'24er Karton',  icon:'🍬' },
    { id:13, name:'M&Ms Crispy 36g',             brand:'Mars',     cat:'Süßwaren', unit:'24er Karton',  icon:'🍬' },
    { id:14, name:'Elfbar 600 Mango Ice',         brand:'Elfbar',   cat:'Vapes',    unit:'10er Box',     icon:'💨' },
    { id:15, name:'Elfbar 600 Watermelon',        brand:'Elfbar',   cat:'Vapes',    unit:'10er Box',     icon:'💨' },
    { id:16, name:'Elfbar 600 Strawberry Ice',    brand:'Elfbar',   cat:'Vapes',    unit:'10er Box',     icon:'💨' },
    { id:17, name:'Elfbar BC5000 Mixed',          brand:'Elfbar',   cat:'Vapes',    unit:'10er Box',     icon:'💨' },
    { id:18, name:'Flerbar M 8000 Mango',         brand:'Flerbar',  cat:'Vapes',    unit:'10er Box',     icon:'💨' },
    { id:19, name:'Flerbar M 8000 Peach Ice',     brand:'Flerbar',  cat:'Vapes',    unit:'10er Box',     icon:'💨' },
    { id:20, name:'Flerbar Y 600 Mixed',          brand:'Flerbar',  cat:'Vapes',    unit:'10er Box',     icon:'💨' },
    { id:21, name:'Red Bull Energy 250ml',        brand:'Red Bull', cat:'Energy',   unit:'24er Tray',    icon:'⚡' },
    { id:22, name:'Red Bull Sugarfree 250ml',     brand:'Red Bull', cat:'Energy',   unit:'24er Tray',    icon:'⚡' },
    { id:23, name:'Red Bull 355ml',               brand:'Red Bull', cat:'Energy',   unit:'12er Tray',    icon:'⚡' },
    { id:24, name:'Pringles Original 165g',       brand:'Pringles', cat:'Snacks',   unit:'12er Karton',  icon:'🥔' },
    { id:25, name:'Pringles Sour Cream 165g',     brand:'Pringles', cat:'Snacks',   unit:'12er Karton',  icon:'🥔' },
    { id:26, name:'Pringles Paprika 165g',        brand:'Pringles', cat:'Snacks',   unit:'12er Karton',  icon:'🥔' },
    { id:27, name:'OCB Premium Slim 50er',        brand:'OCB',      cat:'Headshop', unit:'50er Display', icon:'🌿' },
    { id:28, name:'OCB Organic Hemp 50er',        brand:'OCB',      cat:'Headshop', unit:'50er Display', icon:'🌿' },
    { id:29, name:'RAW Classic King Size',        brand:'RAW',      cat:'Headshop', unit:'50er Display', icon:'🌿' },
    { id:30, name:'RAW Organic Hemp KS',          brand:'RAW',      cat:'Headshop', unit:'50er Display', icon:'🌿' },
    { id:31, name:'Clipper Feuerzeug Box',        brand:'Clipper',  cat:'Headshop', unit:'48er Box',     icon:'🔥' },
    { id:32, name:'Clipper Mini Box',             brand:'Clipper',  cat:'Headshop', unit:'48er Box',     icon:'🔥' },
  ];

  // ── State ────────────────────────────────────────────────────
  var merklist = []; // [{product, qty}]
  var cmdOpen  = false;
  var activeFilter = '';
  var focusedIdx   = -1;
  var filteredProds = PRODUCTS.slice();

  // ── DOM ──────────────────────────────────────────────────────
  var overlay   = document.getElementById('cmdOverlay');
  var input     = document.getElementById('cmdInput');
  var results   = document.getElementById('cmdResults');
  var filters   = document.querySelectorAll('.cmd-filter');

  // Bail out if Command Palette markup not present (Liquid theme uses different structure)
  if (!overlay || !input || !results) return;

  var sidebar   = document.getElementById('merkSidebar');
  var backdrop  = document.getElementById('merkBackdrop');
  var merkTrig  = document.getElementById('merkTrigger');
  var merkClose = document.getElementById('merkClose');
  var merkCount = document.getElementById('merkCount');
  var merkHdCnt = document.getElementById('merkHeaderCount');
  var merkList  = document.getElementById('merkList');
  var merkEmpty = document.getElementById('merkEmpty');
  var merkFooter= document.getElementById('merkFooter');
  var merkSend  = document.getElementById('merkSend');
  var merkClear = document.getElementById('merkClear');
  var merkSumTx = document.getElementById('merkSummaryText');

  // ── Command Palette open/close ───────────────────────────────
  function openCmd() {
    cmdOpen = true;
    overlay.classList.add('open');
    input.value = '';
    input.focus();
    renderResults(PRODUCTS);
    focusedIdx = -1;
  }
  function closeCmd() {
    cmdOpen = false;
    overlay.classList.remove('open');
    focusedIdx = -1;
  }

  // Triggers
  document.getElementById('cmdTriggerNav').addEventListener('click', openCmd);
  overlay.addEventListener('click', function(e) { if (e.target === overlay) closeCmd(); });

  // Keyboard shortcuts
  document.addEventListener('keydown', function(e) {
    // Open: Cmd+K / Ctrl+K / /
    if ((e.metaKey || e.ctrlKey) && e.key === 'k') { e.preventDefault(); cmdOpen ? closeCmd() : openCmd(); return; }
    if (!cmdOpen) return;

    if (e.key === 'Escape') { closeCmd(); return; }
    if (e.key === 'ArrowDown') { e.preventDefault(); moveFocus(1); return; }
    if (e.key === 'ArrowUp')   { e.preventDefault(); moveFocus(-1); return; }
    if (e.key === 'Enter') {
      e.preventDefault();
      var focused = results.querySelector('.cmd-result.focused');
      if (focused) focused.querySelector('.cmd-add').click();
      return;
    }
  });

  function moveFocus(dir) {
    var items = Array.from(results.querySelectorAll('.cmd-result'));
    if (!items.length) return;
    items.forEach(function(i) { i.classList.remove('focused'); });
    focusedIdx = Math.max(0, Math.min(items.length - 1, focusedIdx + dir));
    items[focusedIdx].classList.add('focused');
    items[focusedIdx].scrollIntoView({ block: 'nearest' });
  }

  // ── Filter chips ─────────────────────────────────────────────
  filters.forEach(function(btn) {
    btn.addEventListener('click', function() {
      filters.forEach(function(b) { b.classList.remove('active'); });
      btn.classList.add('active');
      activeFilter = btn.getAttribute('data-cat');
      doSearch();
    });
  });

  // ── Search ───────────────────────────────────────────────────
  input.addEventListener('input', doSearch);

  function doSearch() {
    var q = input.value.toLowerCase().trim();
    filteredProds = PRODUCTS.filter(function(p) {
      var catMatch = !activeFilter || p.cat === activeFilter;
      var qMatch   = !q || p.name.toLowerCase().includes(q) || p.brand.toLowerCase().includes(q) || p.cat.toLowerCase().includes(q);
      return catMatch && qMatch;
    });
    renderResults(filteredProds);
    focusedIdx = -1;
  }

  function renderResults(prods) {
    results.innerHTML = '';
    prods.slice(0, 12).forEach(function(p) {
      var inList = merklist.find(function(m) { return m.product.id === p.id; });
      var li = document.createElement('li');
      li.className = 'cmd-result';
      li.setAttribute('role', 'option');
      li.innerHTML = [
        '<div class="cmd-result-icon">' + p.icon + '</div>',
        '<div class="cmd-result-body">',
          '<div class="cmd-result-name">' + p.name + '</div>',
          '<div class="cmd-result-meta">',
            '<span class="cmd-cat-chip">' + p.cat + '</span>',
            p.brand + ' · ' + p.unit,
          '</div>',
        '</div>',
        '<button class="cmd-add' + (inList ? ' added' : '') + '" aria-label="' + p.name + ' zur Merkliste hinzufügen">',
          inList ? '✓ Gemerkt' : '+ Merken',
        '</button>',
      ].join('');

      var addBtn = li.querySelector('.cmd-add');
      addBtn.addEventListener('click', function(e) {
        e.stopPropagation();
        addToMerkliste(p);
        addBtn.classList.add('added');
        addBtn.textContent = '✓ Gemerkt';
      });
      li.addEventListener('click', function() {
        addToMerkliste(p);
        addBtn.classList.add('added');
        addBtn.textContent = '✓ Gemerkt';
      });
      results.appendChild(li);
    });
  }

  // ── Merkliste logic ──────────────────────────────────────────
  function addToMerkliste(product) {
    var existing = merklist.find(function(m) { return m.product.id === product.id; });
    if (existing) {
      existing.qty++;
    } else {
      merklist.push({ product: product, qty: 1 });
    }
    updateMerklisteUI();
    // Pulse the trigger button
    merkTrig.style.transform = 'scale(1.1)';
    setTimeout(function() { merkTrig.style.transform = ''; }, 200);
  }

  function removeFromMerkliste(id) {
    merklist = merklist.filter(function(m) { return m.product.id !== id; });
    updateMerklisteUI();
    doSearch(); // refresh cmd results
  }

  function changeQty(id, delta) {
    var item = merklist.find(function(m) { return m.product.id === id; });
    if (!item) return;
    item.qty = Math.max(1, item.qty + delta);
    updateMerklisteUI();
  }

  function updateMerklisteUI() {
    var total = merklist.length;
    var totalQty = merklist.reduce(function(s, m) { return s + m.qty; }, 0);

    // Trigger button badge
    merkCount.textContent = total;
    merkCount.classList.toggle('visible', total > 0);

    // Header count
    merkHdCnt.textContent = total + ' Artikel';

    // Empty state
    merkEmpty.style.display = total === 0 ? 'flex' : 'none';
    merkFooter.classList.toggle('visible', total > 0);

    // Summary
    merkSumTx.textContent = total + ' Produkte · ' + totalQty + ' Einheiten';

    // List
    merkList.innerHTML = '';
    merklist.forEach(function(m) {
      var p = m.product;
      var li = document.createElement('li');
      li.className = 'merk-item';
      li.innerHTML = [
        '<div class="merk-item-icon">' + p.icon + '</div>',
        '<div class="merk-item-info">',
          '<div class="merk-item-name">' + p.name + '</div>',
          '<div class="merk-item-unit">' + p.unit + ' · ' + p.brand + '</div>',
        '</div>',
        '<div class="merk-qty">',
          '<button class="merk-qty-btn" data-id="' + p.id + '" data-d="-1" aria-label="Menge verringern">−</button>',
          '<span class="merk-qty-num">' + m.qty + '</span>',
          '<button class="merk-qty-btn" data-id="' + p.id + '" data-d="1" aria-label="Menge erhöhen">+</button>',
        '</div>',
        '<button class="merk-remove" data-id="' + p.id + '" aria-label="' + p.name + ' entfernen">',
          '<svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round"><path d="M18 6L6 18M6 6l12 12"/></svg>',
        '</button>',
      ].join('');

      li.querySelectorAll('.merk-qty-btn').forEach(function(btn) {
        btn.addEventListener('click', function() {
          changeQty(Number(btn.getAttribute('data-id')), Number(btn.getAttribute('data-d')));
        });
      });
      li.querySelector('.merk-remove').addEventListener('click', function(e) {
        removeFromMerkliste(Number(e.currentTarget.getAttribute('data-id')));
      });
      merkList.appendChild(li);
    });
  }

  // ── Merkliste sidebar open/close ─────────────────────────────
  function openMerk() {
    sidebar.classList.add('open');
    backdrop.classList.add('open');
    merkTrig.setAttribute('aria-expanded', 'true');
  }
  function closeMerk() {
    sidebar.classList.remove('open');
    backdrop.classList.remove('open');
    merkTrig.setAttribute('aria-expanded', 'false');
  }

  merkTrig.addEventListener('click', function() {
    sidebar.classList.contains('open') ? closeMerk() : openMerk();
  });
  merkClose.addEventListener('click', closeMerk);
  backdrop.addEventListener('click', closeMerk);

  // ── Send inquiry ─────────────────────────────────────────────
  merkSend.addEventListener('click', function() {
    if (!merklist.length) return;
    var lines = merklist.map(function(m) {
      return '- ' + m.product.name + ' × ' + m.qty + ' ' + m.product.unit;
    }).join('\n');
    var body = 'Hallo GNG Team,\n\nich möchte folgende Produkte anfragen:\n\n' + lines + '\n\nBitte schickt mir ein Angebot.\n\nMit freundlichen Grüßen';
    window.location.href = 'mailto:info@gnggrosshandel.de?subject=Bestellanfrage%20Merkliste&body=' + encodeURIComponent(body);
  });

  // ── Clear all ─────────────────────────────────────────────────
  merkClear.addEventListener('click', function() {
    merklist = [];
    updateMerklisteUI();
    doSearch();
  });

  // ── Close sidebar on Escape ──────────────────────────────────
  document.addEventListener('keydown', function(e) {
    if (e.key === 'Escape' && sidebar.classList.contains('open')) closeMerk();
  });

  // Init
  updateMerklisteUI();

})();

// ── Kategorie Accordion (3 Hauptkategorien) ────────────────────
(function () {
  'use strict';
  var rows = document.querySelectorAll('[data-cat-row]');
  if (!rows.length) return;

  var brandCache = {};
  var productsCache = {};
  var markeCollections = null;
  var ICON_ROTATE_MS = 4000;
  var reduceMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function vendorSlug(v) {
    return v.toLowerCase()
      .replace(/ä/g, 'a').replace(/ö/g, 'o').replace(/ü/g, 'u').replace(/ß/g, 'ss')
      .replace(/['‘’“”]/g, '')
      .replace(/[^a-z0-9]+/g, '-')
      .replace(/^-+|-+$/g, '');
  }

  function getBrandUrl(vendor) {
    var slug = 'marke-' + vendorSlug(vendor);
    if (markeCollections && markeCollections[slug]) {
      return '/collections/' + slug;
    }
    return '/search?type=product&filter.p.vendor=' + encodeURIComponent(vendor);
  }

  function loadMarkeCollections(callback) {
    if (markeCollections) { callback(); return; }
    fetch('/collections.json?limit=250')
      .then(function (r) { return r.json(); })
      .then(function (data) {
        markeCollections = {};
        (data.collections || []).forEach(function (c) {
          if (c.handle && c.handle.indexOf('marke-') === 0) {
            markeCollections[c.handle] = true;
          }
        });
        callback();
      })
      .catch(function () {
        markeCollections = {};
        callback();
      });
  }

  // Produkte einer Collection laden (geteilter Cache: Marken-Grid + Kategorie-Bild)
  function fetchProducts(handle, callback) {
    if (productsCache[handle]) { callback(productsCache[handle]); return; }
    fetch('/collections/' + handle + '/products.json?limit=250')
      .then(function (r) { return r.json(); })
      .then(function (data) {
        productsCache[handle] = data.products || [];
        callback(productsCache[handle]);
      })
      .catch(function () { callback(null); });
  }

  function shuffle(arr) {
    for (var i = arr.length - 1; i > 0; i--) {
      var j = Math.floor(Math.random() * (i + 1));
      var t = arr[i]; arr[i] = arr[j]; arr[j] = t;
    }
    return arr;
  }

  // Shopify-CDN-URL auf quadratischen Crop in passender Größe bringen
  function sizedImg(src, px) {
    if (!src) return src;
    return src + (src.indexOf('?') > -1 ? '&' : '?') + 'width=' + px + '&height=' + px + '&crop=center';
  }

  // Zufälliges Produktbild statt Icon einblenden, sanft rotierend
  function initCategoryImage(row) {
    var iconBox = row.querySelector('.cat-row-icon');
    var grid = row.querySelector('[data-brand-grid]');
    if (!iconBox || !grid) return;
    var handle = grid.dataset.collectionHandle;
    if (!handle) return;

    fetchProducts(handle, function (products) {
      if (!products || !products.length) return; // Fallback: Icon bleibt stehen
      var imgs = [];
      products.forEach(function (p) {
        if (p.images && p.images[0]) imgs.push(sizedImg(p.images[0].src, 300));
      });
      if (!imgs.length) return;
      renderCategoryPhotos(iconBox, shuffle(imgs));
    });
  }

  var ICON_SLIDE_MS = 700;

  function renderCategoryPhotos(iconBox, imgs) {
    iconBox.classList.add('cat-row-icon--photo');
    var layerA = document.createElement('div');
    var layerB = document.createElement('div');
    layerA.className = 'cat-icon-photo';
    layerB.className = 'cat-icon-photo';
    iconBox.appendChild(layerA);
    iconBox.appendChild(layerB);

    var current = layerA;
    var parked = layerB;
    current.style.backgroundImage = 'url(' + imgs[0] + ')';
    current.style.transform = 'translateX(0)';
    parked.style.transform = 'translateX(100%)';

    if (imgs.length < 2 || reduceMotion) return; // statisch lassen

    var idx = 0;
    setInterval(function () {
      idx = (idx + 1) % imgs.length;
      var incoming = parked;
      var outgoing = current;
      incoming.style.backgroundImage = 'url(' + imgs[idx] + ')';
      // Nächster Frame: rein-/raussliden
      requestAnimationFrame(function () {
        incoming.style.transform = 'translateX(0)';
        outgoing.style.transform = 'translateX(-100%)';
      });
      // Nach dem Slide das ausgeschiedene Layer unsichtbar nach rechts zurücksetzen
      setTimeout(function () {
        outgoing.style.transition = 'none';
        outgoing.style.transform = 'translateX(100%)';
        void outgoing.offsetWidth; // Reflow erzwingen
        outgoing.style.transition = '';
      }, ICON_SLIDE_MS);
      current = incoming;
      parked = outgoing;
    }, ICON_ROTATE_MS);
  }

  function setOpen(row, open) {
    var head = row.querySelector('[data-cat-toggle]');
    var btn  = row.querySelector('[data-cat-toggle-btn]');
    row.classList.toggle('open', open);
    if (head) head.setAttribute('aria-expanded', open ? 'true' : 'false');
    if (btn)  btn.setAttribute('aria-label', open ? 'Einklappen' : 'Aufklappen');
    if (open) loadBrands(row);
  }

  function loadBrands(row) {
    var grid = row.querySelector('[data-brand-grid]');
    if (!grid || grid.dataset.loaded) return;
    var handle = grid.dataset.collectionHandle;
    if (!handle) return;

    loadMarkeCollections(function () {
      if (brandCache[handle]) {
        renderBrands(grid, brandCache[handle]);
        return;
      }
      fetchProducts(handle, function (products) {
        if (!products) {
          grid.innerHTML = '<p class="cat-sub-empty">Konnte Marken nicht laden.</p>';
          return;
        }
        var vendors = {};
        products.forEach(function (p) {
          if (!p.vendor) return;
          if (!vendors[p.vendor]) {
            vendors[p.vendor] = { count: 0, image: null };
          }
          vendors[p.vendor].count++;
          if (!vendors[p.vendor].image && p.images && p.images[0]) {
            vendors[p.vendor].image = p.images[0].src;
          }
        });
        brandCache[handle] = Object.keys(vendors)
          .sort(function (a, b) { return vendors[b].count - vendors[a].count; })
          .map(function (v) { return { name: v, count: vendors[v].count, image: vendors[v].image }; });
        renderBrands(grid, brandCache[handle]);
      });
    });
  }

  function renderBrands(grid, brands) {
    grid.dataset.loaded = '1';
    grid.innerHTML = '';
    brands.forEach(function (b) {
      var a = document.createElement('a');
      a.href = getBrandUrl(b.name);
      a.className = 'cat-brand-card';
      var imgHtml = b.image
        ? '<div class="cat-brand-img" style="background-image:url(' + b.image + ')"></div>'
        : '<div class="cat-brand-img cat-brand-img--empty"></div>';
      a.innerHTML =
        imgHtml +
        '<div class="cat-brand-text">' +
          '<span class="cat-brand-name">' + b.name + '</span>' +
          '<span class="cat-brand-count">' + b.count + ' Produkte</span>' +
        '</div>';
      grid.appendChild(a);
    });
  }

  function toggle(row) {
    var willOpen = !row.classList.contains('open');
    rows.forEach(function (r) { if (r !== row) setOpen(r, false); });
    setOpen(row, willOpen);
  }

  rows.forEach(function (row) {
    initCategoryImage(row);
    var head = row.querySelector('[data-cat-toggle]');
    if (!head) return;
    head.addEventListener('click', function (e) {
      if (e.target.closest('.cat-row-link')) return;
      toggle(row);
    });
    head.addEventListener('keydown', function (e) {
      if (e.key === 'Enter' || e.key === ' ') {
        e.preventDefault();
        toggle(row);
      }
    });
  });
})();

// ── Starterpaket Tab Switcher ──────────────────────────────────
(function () {
  'use strict';
  var tabs   = document.querySelectorAll('.starter-tab');
  var panels = document.querySelectorAll('.starter-panel');
  if (!tabs.length) return;

  tabs.forEach(function (tab) {
    tab.addEventListener('click', function () {
      var targetId = tab.getAttribute('data-target');

      // Update tabs
      tabs.forEach(function (t) {
        t.classList.remove('active');
        t.setAttribute('aria-selected', 'false');
      });
      tab.classList.add('active');
      tab.setAttribute('aria-selected', 'true');

      // Update panels
      panels.forEach(function (panel) {
        panel.classList.remove('active');
      });
      var target = document.getElementById(targetId);
      if (target) {
        target.classList.add('active');
        // Animate progress bars in new panel
        target.querySelectorAll('.starter-item-fill').forEach(function (fill) {
          var w = fill.style.width;
          fill.style.width = '0';
          setTimeout(function () { fill.style.width = w; }, 60);
        });
      }
    });
  });
})();

// ── Feature Carousel (B2B 4 Steps) ────────────────────────────
(function () {
  'use strict';

  // ── Step data ─────────────────────────────────────────────
  var STEPS = [
    {
      label: 'Schritt 1',
      title: 'Kostenlos\nregistrieren',
      desc:  'Erstellen Sie Ihren B2B-Account in wenigen Minuten. Einfaches Online-Formular – kostenlos und unverbindlich.',
      alt:   'Händler registriert sich am Laptop, daneben versandfertige Pakete',
    },
    {
      label: 'Schritt 2',
      title: 'Nachweis\neinreichen',
      desc:  'Laden Sie Ihren Gewerbeschein hoch, die USt-IdNr. ist freiwillig. Wir prüfen Ihren Antrag in der Regel innerhalb eines Werktags.',
      alt:   'Gewerbeschein und Handelsregisterauszug auf dem Schreibtisch',
    },
    {
      label: 'Schritt 3',
      title: 'B2B-Zugang\nerhalten',
      desc:  'Nach der Freischaltung sehen Sie alle Großhandelspreise – für über 1.300 Artikel.',
      alt:   'B2B-Dashboard mit Großhandelspreisen',
    },
    {
      label: 'Schritt 4',
      title: 'Bestellen',
      desc:  'Lieferung in 1–3 Werktagen ab 395 € netto – oder Abholung in Hannover ohne Mindestbestellwert. Zahlung per Vorkasse, Rechnung nach Freigabe.',
      alt:   'Versandfertige Pakete auf dem Förderband mit Lieferwagen',
    },
  ];

  // ── DOM refs ──────────────────────────────────────────────
  var wrap       = document.getElementById('featCardWrap');
  var textCol    = document.getElementById('featTextCol');
  var labelEl    = document.getElementById('featLabel');
  var titleEl    = document.getElementById('featTitle');
  var descEl     = document.getElementById('featDesc');
  var imgCol     = document.getElementById('featImgCol');
  var navEl      = document.getElementById('featNav');
  var progressEl = document.getElementById('featProgressFill');
  if (!wrap) return;

  // Bild-URLs (Theme-Assets) aus den data-Attributen der Section
  var STEP_IMGS = [
    wrap.dataset.img1,
    wrap.dataset.img2,
    wrap.dataset.img3,
    wrap.dataset.img4,
  ];

  var current    = 0;
  var autoTimer  = null;
  var switchTimer= null;
  var INTERVAL   = 5000;

  // ── Build nav pills ───────────────────────────────────────
  STEPS.forEach(function (s, i) {
    var btn = document.createElement('button');
    btn.className = 'feat-pill' + (i === 0 ? ' active' : '');
    btn.setAttribute('aria-label', s.label + ' anzeigen');
    btn.setAttribute('aria-current', i === 0 ? 'step' : 'false');
    btn.innerHTML =
      '<span class="feat-pill-dot">' + (i + 1) + '</span>' +
      '<span>' + s.label + '</span>';
    btn.addEventListener('click', function () {
      clearInterval(autoTimer);
      goTo(i);
      startAuto();
    });
    navEl.appendChild(btn);
  });

  // ── Mouse glow on card ────────────────────────────────────
  wrap.addEventListener('mousemove', function (e) {
    var r = wrap.getBoundingClientRect();
    wrap.style.setProperty('--mx', (e.clientX - r.left) + 'px');
    wrap.style.setProperty('--my', (e.clientY - r.top)  + 'px');
  });
  wrap.addEventListener('mouseleave', function () {
    wrap.style.setProperty('--mx', '-9999px');
    wrap.style.setProperty('--my', '-9999px');
  });

  // ── Render image ──────────────────────────────────────────
  function renderImgs(idx) {
    imgCol.innerHTML = '';
    var src = STEP_IMGS[idx];
    if (!src) return;
    var el = document.createElement('img');
    el.src       = src;
    el.alt       = STEPS[idx].alt || '';
    el.className = 'feat-anim-c';
    el.loading   = 'lazy';
    imgCol.appendChild(el);
  }

  // ── Go to step ────────────────────────────────────────────
  function goTo(idx) {
    if (idx === current) return;
    var prev = current;
    current  = idx;

    // Fade out
    textCol.style.opacity   = '0';
    textCol.style.transform = 'translateY(-10px)';
    imgCol.style.opacity    = '0';

    clearTimeout(switchTimer);
    switchTimer = setTimeout(function () {
      var s = STEPS[idx];
      labelEl.textContent = s.label;
      titleEl.innerHTML   = s.title.replace('\n', '<br>');
      descEl.textContent  = s.desc;
      renderImgs(idx);

      // Fade in
      textCol.style.opacity   = '1';
      textCol.style.transform = 'translateY(0)';
      imgCol.style.opacity    = '1';
    }, 340);

    // Update pills
    navEl.querySelectorAll('.feat-pill').forEach(function (pill, i) {
      var isActive = i === idx;
      pill.classList.toggle('active', isActive);
      pill.setAttribute('aria-current', isActive ? 'step' : 'false');

      // Check mark for completed steps
      var dot = pill.querySelector('.feat-pill-dot');
      if (i < idx) {
        dot.innerHTML = '<svg width="10" height="10" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="3.5" stroke-linecap="round" aria-hidden="true"><path d="M5 13l4 4L19 7"/></svg>';
      } else {
        dot.textContent = String(i + 1);
      }
    });

    // Restart progress bar
    restartProgress();
  }

  // ── Progress bar ──────────────────────────────────────────
  function restartProgress() {
    progressEl.classList.remove('running');
    void progressEl.offsetWidth; // reflow to restart animation
    progressEl.classList.add('running');
  }

  // ── Auto-cycle ────────────────────────────────────────────
  function startAuto() {
    clearInterval(autoTimer);
    autoTimer = setInterval(function () {
      goTo((current + 1) % STEPS.length);
    }, INTERVAL);
  }

  // ── Initial render ────────────────────────────────────────
  renderImgs(0);
  restartProgress();
  startAuto();

  // Pause on hover
  wrap.addEventListener('mouseenter', function () { clearInterval(autoTimer); });
  wrap.addEventListener('mouseleave', function () { startAuto(); });

})();

// ── Produkt Spotlight ──────────────────────────────────────────
//
// Reads real product data from the Liquid-rendered DOM:
//   - <div class="spotlight-product-image" data-spot-image="N"> with <img> for each product
//   - <div data-spot-idx="N" data-title=… data-brand=… data-url=… data-desc=… data-m1-label=… …>
//   - <button class="spotlight-pill" data-spot-pill="N">
//
// No hardcoded product list anymore — drives entirely from section.blocks.
(function () {
  'use strict';

  var dataEls    = document.querySelectorAll('.spotlight-data [data-spot-idx]');
  var images     = document.querySelectorAll('.spotlight-product-image[data-spot-image]');
  var pills      = document.querySelectorAll('.spotlight-pill[data-spot-pill]');
  var eyebrowEl  = document.getElementById('spotEyebrow');
  var titleEl    = document.getElementById('spotTitle');
  var descEl     = document.getElementById('spotDesc');
  var metricsEl  = document.getElementById('spotMetrics');
  var ctaEl      = document.getElementById('spotCta');

  if (!dataEls.length || !titleEl || !descEl) return;

  // Build a lightweight product index from the data attributes (skip empty blocks).
  var PRODUCTS = Array.from(dataEls).map(function (el) {
    var metrics = [];
    [1, 2, 3].forEach(function (n) {
      var label = el.getAttribute('data-m' + n + '-label');
      var value = parseInt(el.getAttribute('data-m' + n + '-value') || '0', 10);
      if (label) metrics.push({ label: label, value: value });
    });
    return {
      title: el.getAttribute('data-title') || '',
      brand: el.getAttribute('data-brand') || '',
      url:   el.getAttribute('data-url')   || '#',
      desc:  el.getAttribute('data-desc')  || '',
      metrics: metrics,
    };
  }).filter(function (p) { return p.title && p.title !== ''; });

  // Hide entire section if no real products are configured
  if (PRODUCTS.length === 0) {
    var emptySection = document.querySelector('.spotlight-section, .shopify-section-spotlight');
    if (emptySection) emptySection.style.display = 'none';
    return;
  }

  var current   = 0;
  var autoTimer = null;
  var INTERVAL  = 5500;

  function render(idx) {
    if (idx < 0 || idx >= PRODUCTS.length) return;
    current = idx;
    var p = PRODUCTS[idx];

    // Toggle product image visibility
    images.forEach(function (img, i) {
      if (i === idx) img.setAttribute('data-active', ''); else img.removeAttribute('data-active');
    });

    // Toggle active pill
    pills.forEach(function (pill, i) {
      var active = i === idx;
      pill.classList.toggle('active', active);
      pill.setAttribute('aria-selected', String(active));
    });

    // Update text
    if (eyebrowEl) eyebrowEl.textContent = p.brand;
    titleEl.textContent = p.title;
    descEl.textContent = p.desc;
    if (ctaEl) ctaEl.setAttribute('href', p.url);

    // Build metric bars
    if (metricsEl) {
      metricsEl.innerHTML = '';
      p.metrics.forEach(function (m) {
        var row = document.createElement('div');
        row.className = 'spot-metric';
        row.innerHTML =
          '<div class="spot-metric-header">' +
            '<span class="spot-metric-label">' + m.label + '</span>' +
            '<span class="spot-metric-val">' + m.value + '%</span>' +
          '</div>' +
          '<div class="spot-metric-track"><div class="spot-metric-fill" style="width:0"></div></div>';
        metricsEl.appendChild(row);
        requestAnimationFrame(function () {
          setTimeout(function () {
            var fill = row.querySelector('.spot-metric-fill');
            if (fill) fill.style.width = m.value + '%';
          }, 120);
        });
      });
    }
  }

  function next() { render((current + 1) % PRODUCTS.length); }

  function startAuto() {
    clearInterval(autoTimer);
    if (PRODUCTS.length > 1) autoTimer = setInterval(next, INTERVAL);
  }

  pills.forEach(function (pill, i) {
    pill.addEventListener('click', function () {
      clearInterval(autoTimer);
      render(i);
      startAuto();
    });
  });

  // Pause auto-cycle on hover over the whole section
  var section = document.querySelector('.spotlight-section, .shopify-section-spotlight');
  if (section) {
    section.addEventListener('mouseenter', function () { clearInterval(autoTimer); });
    section.addEventListener('mouseleave', startAuto);
  }

  render(0);
  startAuto();

  return; // skip the legacy preview code below
})();

// ── Legacy spotlight (preview-only mock data) — kept dead-code to avoid breaking other unrelated IIFEs
(function () {
  'use strict';
  if (true) return; // disabled

  var SVGS = {
    snickers: `<svg width="260" height="180" viewBox="0 0 280 200" fill="none" xmlns="http://www.w3.org/2000/svg">
      <rect x="20" y="55" width="240" height="105" rx="18" fill="#3d1c02"/>
      <rect x="20" y="55" width="240" height="52" rx="18" fill="#4a2208"/>
      <rect x="20" y="84" width="240" height="26" fill="#d4830a"/>
      <ellipse cx="55" cy="68" rx="9" ry="6" fill="#c8860a"/>
      <ellipse cx="82" cy="63" rx="8" ry="5.5" fill="#b87800"/>
      <ellipse cx="112" cy="67" rx="9" ry="6" fill="#c8860a"/>
      <ellipse cx="140" cy="61" rx="8" ry="5.5" fill="#b87800"/>
      <ellipse cx="168" cy="67" rx="9" ry="6" fill="#c8860a"/>
      <ellipse cx="198" cy="63" rx="8" ry="5.5" fill="#b87800"/>
      <ellipse cx="224" cy="68" rx="9" ry="6" fill="#c8860a"/>
      <text x="140" y="145" font-family="Arial Black,sans-serif" font-size="26" font-weight="900" fill="white" text-anchor="middle" letter-spacing="3">SNICKERS</text>
      <path d="M60 160 Q58 175 55 185 Q53 193 59 193 Q65 194 67 186 Q69 177 67 160Z" fill="#d4830a"/>
      <path d="M105 160 Q104 171 102 180 Q100 187 105 188 Q110 189 112 182 Q114 174 113 160Z" fill="#c8790a"/>
      <path d="M155 160 Q153 174 151 183 Q149 190 154 191 Q159 192 161 185 Q163 176 162 160Z" fill="#d4830a"/>
      <path d="M205 160 Q204 170 202 178 Q200 184 205 185 Q210 186 212 179 Q214 171 213 160Z" fill="#c8790a"/>
    </svg>`,

    elfbar: `<svg width="120" height="260" viewBox="0 0 160 280" fill="none" xmlns="http://www.w3.org/2000/svg">
      <defs>
        <linearGradient id="sg_vg" x1="0" y1="0" x2="1" y2="1">
          <stop offset="0%" stop-color="#a8d8f0"/>
          <stop offset="50%" stop-color="#3a8fce"/>
          <stop offset="100%" stop-color="#0f2a5a"/>
        </linearGradient>
        <linearGradient id="sg_sh" x1="0" y1="0" x2="1" y2="0">
          <stop offset="0%" stop-color="rgba(255,255,255,.25)"/>
          <stop offset="100%" stop-color="rgba(0,0,0,.1)"/>
        </linearGradient>
      </defs>
      <rect x="40" y="28" width="80" height="222" rx="22" fill="url(#sg_vg)"/>
      <rect x="40" y="28" width="28" height="222" rx="22" fill="url(#sg_sh)"/>
      <rect x="55" y="16" width="50" height="18" rx="10" fill="#6ab8e0"/>
      <rect x="68" y="10" width="24" height="10" rx="5" fill="#3a8fce"/>
      <text x="80" y="90" font-family="Arial Black,sans-serif" font-size="11" font-weight="900" fill="rgba(255,255,255,.9)" text-anchor="middle" letter-spacing="2" writing-mode="tb">ELFBAR</text>
      <ellipse cx="80" cy="228" rx="8" ry="4.5" fill="rgba(255,255,255,.55)"/>
      <ellipse cx="80" cy="228" rx="4" ry="2.2" fill="rgba(255,255,255,.9)"/>
      <rect x="42" y="158" width="76" height="3" rx="1.5" fill="rgba(255,255,255,.25)"/>
      <circle cx="80" cy="4" r="7" fill="rgba(255,255,255,.35)" style="filter:blur(3px)"/>
      <circle cx="68" cy="0" r="5" fill="rgba(255,255,255,.2)" style="filter:blur(2px)"/>
      <circle cx="92" cy="-2" r="6" fill="rgba(255,255,255,.25)" style="filter:blur(2px)"/>
    </svg>`,

    haribo: `<svg width="210" height="260" viewBox="0 0 220 270" fill="none" xmlns="http://www.w3.org/2000/svg">
      <defs>
        <linearGradient id="sg_bg" x1=".1" y1="0" x2=".9" y2="1">
          <stop offset="0%" stop-color="#FFE033"/>
          <stop offset="100%" stop-color="#FFB800"/>
        </linearGradient>
      </defs>
      <path d="M30 80 Q20 85 18 100 L15 240 Q14 258 110 260 Q206 258 205 240 L202 100 Q200 85 190 80 L155 40 Q140 20 110 18 Q80 20 65 40 Z" fill="url(#sg_bg)"/>
      <path d="M65 40 Q80 32 110 30 Q140 32 155 40 L170 65 Q140 58 110 57 Q80 58 50 65 Z" fill="rgba(0,0,0,.08)"/>
      <path d="M35 90 Q28 100 27 120 L26 180 Q34 165 38 120 Z" fill="rgba(255,255,255,.22)"/>
      <ellipse cx="110" cy="35" rx="55" ry="22" fill="#e02020"/>
      <text x="110" y="41" font-family="Arial Black,sans-serif" font-size="13" font-weight="900" fill="#FFE033" text-anchor="middle" letter-spacing="1">HARIBO</text>
      <text x="110" y="158" font-family="Arial Black,sans-serif" font-size="30" font-weight="900" fill="#CC8800" text-anchor="middle" letter-spacing="2">HARIBO</text>
      <text x="110" y="178" font-family="Arial,sans-serif" font-size="10" fill="#CC8800" text-anchor="middle" letter-spacing="1">GOLDBÄREN</text>
      <circle cx="65" cy="198" r="10" fill="#e02020" opacity=".85"/>
      <circle cx="90" cy="210" r="10" fill="#ff8c00" opacity=".85"/>
      <circle cx="115" cy="200" r="10" fill="#22b022" opacity=".85"/>
      <circle cx="140" cy="210" r="10" fill="#dd2222" opacity=".85"/>
      <circle cx="160" cy="198" r="9"  fill="#ff8c00" opacity=".85"/>
      <circle cx="80"  cy="224" r="9"  fill="#22b022" opacity=".85"/>
      <circle cx="108" cy="228" r="9"  fill="#e02020" opacity=".85"/>
      <circle cx="135" cy="224" r="9"  fill="#ff8c00" opacity=".85"/>
    </svg>`,

    mentos: `<svg width="200" height="220" viewBox="0 0 200 220" fill="none" xmlns="http://www.w3.org/2000/svg">
      <defs>
        <linearGradient id="sg_mg" x1="0" y1="0" x2="0" y2="1">
          <stop offset="0%" stop-color="#ef4444"/>
          <stop offset="100%" stop-color="#b91c1c"/>
        </linearGradient>
      </defs>
      <rect x="55" y="10" width="90" height="195" rx="14" fill="url(#sg_mg)"/>
      <rect x="55" y="10" width="25" height="195" rx="14" fill="rgba(255,255,255,.12)"/>
      <rect x="55" y="10" width="90" height="36" rx="14" fill="rgba(255,255,255,.15)"/>
      <text x="100" y="36" font-family="Arial Black,sans-serif" font-size="14" font-weight="900" fill="white" text-anchor="middle" letter-spacing="1.5">MENTOS</text>
      <circle cx="100" cy="80"  r="16" fill="rgba(255,255,255,.9)"/>
      <circle cx="100" cy="114" r="16" fill="rgba(255,255,255,.9)"/>
      <circle cx="100" cy="148" r="16" fill="rgba(255,255,255,.9)"/>
      <circle cx="100" cy="182" r="16" fill="rgba(255,255,255,.9)"/>
      <circle cx="100" cy="80"  r="10" fill="#e53e3e"/>
      <circle cx="100" cy="114" r="10" fill="#e53e3e"/>
      <circle cx="100" cy="148" r="10" fill="#e53e3e"/>
      <circle cx="100" cy="182" r="10" fill="#e53e3e"/>
    </svg>`,

    redbull: `<svg width="110" height="250" viewBox="0 0 110 250" fill="none" xmlns="http://www.w3.org/2000/svg">
      <defs>
        <linearGradient id="sg_rg" x1="0" y1="0" x2="0" y2="1">
          <stop offset="0%" stop-color="#60a5fa"/>
          <stop offset="100%" stop-color="#1e3a8a"/>
        </linearGradient>
      </defs>
      <path d="M25 30 Q20 35 18 50 L16 210 Q16 228 55 230 Q94 228 94 210 L92 50 Q90 35 85 30 L75 18 Q65 8 55 8 Q45 8 35 18 Z" fill="url(#sg_rg)"/>
      <path d="M25 30 Q35 24 55 22 Q75 24 85 30 L88 50 Q65 44 55 44 Q45 44 22 50 Z" fill="rgba(255,255,255,.2)"/>
      <text x="55" y="105" font-family="Arial Black,sans-serif" font-size="10" font-weight="900" fill="rgba(255,255,255,.9)" text-anchor="middle" letter-spacing="1" writing-mode="tb">RED BULL</text>
      <ellipse cx="55" cy="220" rx="34" ry="9" fill="rgba(255,255,255,.15)"/>
      <path d="M30 46 Q28 60 27 90 L28 130 Q36 115 38 80 Z" fill="rgba(255,255,255,.15)"/>
    </svg>`,
  };

  // ── Product data ──────────────────────────────────────────
  var PRODUCTS = [
    {
      id: 'snickers',
      pill: 'Snickers',
      eyebrow: 'Mars Inc. · Chocolate Bar',
      title: 'SNICKERS\nORIGINAL',
      desc: 'Der Klassiker im Süßwarenregal. Karamell, Erdnüsse und Schokolade – unangefochtener Bestseller in jedem Shop.',
      svg: 'snickers',
      accent: 'rgba(180,80,0,0.45)',
      glowBg: 'rgba(180,80,0,0.35)',
      dotColor: '#d4830a',
      bg: 'radial-gradient(circle at 30% 50%, rgba(180,80,0,0.18), transparent 55%)',
      metrics: [
        { label: 'Abverkaufsrate', val: 94, color: '#d4830a' },
        { label: 'Marge (∅ 35%)', val: 72, color: '#c8860a' },
      ],
      meta: 'ab 12,90 € · 24er Karton',
    },
    {
      id: 'elfbar',
      pill: 'Elfbar',
      eyebrow: 'Elfbar · Einweg-Vape',
      title: 'ELFBAR\nBC5000',
      desc: 'Meistverkaufter Einweg-Vape in Deutschland. 5.000 Züge, 13ml, 40+ Geschmacksrichtungen. Dreht sich von selbst.',
      svg: 'elfbar',
      accent: 'rgba(59,130,246,0.45)',
      glowBg: 'rgba(59,130,246,0.35)',
      dotColor: '#60a5fa',
      bg: 'radial-gradient(circle at 70% 50%, rgba(59,130,246,0.2), transparent 55%)',
      metrics: [
        { label: 'Nachfrage-Index', val: 98, color: '#3b82f6' },
        { label: 'Rotation / Woche', val: 88, color: '#60a5fa' },
      ],
      meta: 'ab 89,90 € · 10er Box',
    },
    {
      id: 'haribo',
      pill: 'Haribo',
      eyebrow: 'Haribo · Fruchtgummi',
      title: 'GOLDBÄREN\nMEGA-BOX',
      desc: 'Deutschlands Lieblings-Gummibär. Impulskauf-König an jeder Kasse. Hohe Marge, schnelle Rotation, breite Zielgruppe.',
      svg: 'haribo',
      accent: 'rgba(202,138,4,0.45)',
      glowBg: 'rgba(202,138,4,0.35)',
      dotColor: '#fbbf24',
      bg: 'radial-gradient(circle at 50% 60%, rgba(202,138,4,0.2), transparent 55%)',
      metrics: [
        { label: 'Beliebtheit', val: 91, color: '#f59e0b' },
        { label: 'Umsatz-Potenzial', val: 78, color: '#fbbf24' },
      ],
      meta: 'ab 18,50 € · 48er Karton',
    },
    {
      id: 'mentos',
      pill: 'Mentos',
      eyebrow: 'Mentos · Kaugummi',
      title: 'MENTOS\nROLLE',
      desc: 'Klassiker für Impulsverkäufe direkt an der Kasse. Kleine Fläche, großer Umsatz. Perfekt für jeden Checkout.',
      svg: 'mentos',
      accent: 'rgba(220,38,38,0.45)',
      glowBg: 'rgba(220,38,38,0.35)',
      dotColor: '#f87171',
      bg: 'radial-gradient(circle at 35% 45%, rgba(220,38,38,0.18), transparent 55%)',
      metrics: [
        { label: 'Impulsrate', val: 86, color: '#ef4444' },
        { label: 'Marge (∅ 42%)', val: 82, color: '#f87171' },
      ],
      meta: 'ab 9,90 € · 40er Display',
    },
    {
      id: 'redbull',
      pill: 'Red Bull',
      eyebrow: 'Red Bull GmbH · Energy Drink',
      title: 'RED BULL\n250ML',
      desc: 'Energie-Drink Nr. 1 weltweit. Hoher Bekanntheitsgrad, starke Nachfrage, konstante Rotation – ein Must-Have.',
      svg: 'redbull',
      accent: 'rgba(37,99,235,0.45)',
      glowBg: 'rgba(37,99,235,0.35)',
      dotColor: '#93c5fd',
      bg: 'radial-gradient(circle at 65% 50%, rgba(37,99,235,0.2), transparent 55%)',
      metrics: [
        { label: 'Markenbekanntheit', val: 99, color: '#3b82f6' },
        { label: 'Rotation / Woche', val: 93, color: '#93c5fd' },
      ],
      meta: 'ab 24,90 € · 24er Tray',
    },
  ];

  // ── DOM refs ──────────────────────────────────────────────
  var bg        = document.getElementById('spotlightBg');
  var glow      = document.getElementById('spotGlow');
  var ring1     = document.getElementById('spotRing1');
  var svgStage  = document.getElementById('spotSvgStage');
  var statusDot = document.getElementById('spotDot');
  var statusTxt = document.getElementById('spotStatusText');
  var eyebrow   = document.getElementById('spotEyebrow');

  // Bail out if Spotlight markup not present (Liquid theme uses different structure)
  if (!bg || !svgStage) return;
  var title     = document.getElementById('spotTitle');
  var desc      = document.getElementById('spotDesc');
  var metrics   = document.getElementById('spotMetrics');
  var meta      = document.getElementById('spotMeta');
  var switcher  = document.getElementById('spotSwitcher');
  var infoEl    = document.getElementById('spotInfo');

  var current   = 0;
  var autoTimer = null;

  // ── Build switcher pills ──────────────────────────────────
  PRODUCTS.forEach(function (p, i) {
    var btn = document.createElement('button');
    btn.className = 'spot-pill' + (i === 0 ? ' active' : '');
    btn.setAttribute('role', 'tab');
    btn.setAttribute('aria-selected', i === 0 ? 'true' : 'false');
    btn.setAttribute('aria-label', p.pill + ' anzeigen');

    if (i === 0) {
      btn.innerHTML = '<div class="spot-pill-bg"></div><span>' + p.pill + '</span><div class="spot-pill-line"></div>';
    } else {
      btn.innerHTML = '<span>' + p.pill + '</span>';
    }

    btn.addEventListener('click', function () {
      clearInterval(autoTimer);
      goTo(i);
      startAuto();
    });
    switcher.appendChild(btn);
  });

  // ── Render product ──────────────────────────────────────
  function goTo(index) {
    var p = PRODUCTS[index];
    current = index;

    // Update pills
    switcher.querySelectorAll('.spot-pill').forEach(function (pill, i) {
      var active = i === index;
      pill.classList.toggle('active', active);
      pill.setAttribute('aria-selected', String(active));
      pill.innerHTML = active
        ? '<div class="spot-pill-bg"></div><span>' + PRODUCTS[i].pill + '</span><div class="spot-pill-line"></div>'
        : '<span>' + PRODUCTS[i].pill + '</span>';
    });

    // Background
    bg.style.background = p.bg;

    // Glow + ring tint
    glow.style.background = p.glowBg;
    ring1.style.borderColor = p.accent;
    statusDot.style.background = p.dotColor;

    // SVG swap with exit/enter classes
    var oldWrapper = svgStage.querySelector('div');
    if (oldWrapper) {
      oldWrapper.classList.remove('spot-svg-active');
      oldWrapper.classList.add('spot-svg-exit');
      setTimeout(function () { if (oldWrapper.parentNode) oldWrapper.parentNode.removeChild(oldWrapper); }, 280);
    }
    setTimeout(function () {
      var wrapper = document.createElement('div');
      wrapper.innerHTML = SVGS[p.svg];
      wrapper.className = 'spot-svg-active';
      svgStage.appendChild(wrapper);
    }, oldWrapper ? 100 : 0);

    // Info fade
    infoEl.style.animation = 'none';
    infoEl.offsetHeight; // reflow
    infoEl.style.animation = '';
    infoEl.classList.remove('spot-info-entering');
    void infoEl.offsetWidth;
    infoEl.classList.add('spot-info-entering');

    // Text content
    eyebrow.textContent = p.eyebrow;
    title.textContent = p.title.replace('\n', ' ');
    title.innerHTML = p.title.split('\n').join('<br>');
    desc.textContent = p.desc;
    statusTxt.textContent = 'Bestseller';

    // Metrics
    metrics.innerHTML = '';
    p.metrics.forEach(function (m) {
      var row = document.createElement('div');
      row.className = 'spot-metric';
      row.innerHTML = [
        '<div class="spot-metric-header">',
          '<span class="spot-metric-label">' + m.label + '</span>',
          '<span class="spot-metric-val">' + m.val + '%</span>',
        '</div>',
        '<div class="spot-metric-track">',
          '<div class="spot-metric-fill" style="background:' + m.color + ';width:0"></div>',
        '</div>',
      ].join('');
      metrics.appendChild(row);
      // Trigger bar animation
      requestAnimationFrame(function () {
        setTimeout(function () {
          var fill = row.querySelector('.spot-metric-fill');
          if (fill) fill.style.width = m.val + '%';
        }, 120);
      });
    });

    // Meta
    meta.innerHTML = [
      '<svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" aria-hidden="true"><rect x="3" y="11" width="18" height="11" rx="2"/><path d="M7 11V7a5 5 0 0110 0v4"/></svg>',
      'Preis nach Login &nbsp;·&nbsp; ' + p.meta,
    ].join('');
  }

  // ── Auto-rotate ──────────────────────────────────────────
  function startAuto() {
    autoTimer = setInterval(function () {
      goTo((current + 1) % PRODUCTS.length);
    }, 4000);
  }

  // ── Init ─────────────────────────────────────────────────
  goTo(0);
  startAuto();

  // Pause on hover
  var spotSection = document.querySelector('.spotlight-section');
  if (spotSection) {
    spotSection.addEventListener('mouseenter', function () { clearInterval(autoTimer); });
    spotSection.addEventListener('mouseleave', startAuto);
  }

})();

// ── Auth page tab switcher ─────────────────────────────────────
(function () {
  'use strict';

  var container = document.querySelector('[data-tabs]');
  if (!container) return;

  function activateTab(name) {
    // Update tab buttons (.auth-tab on account page, .tab on product page)
    container.querySelectorAll('.auth-tab, .tab').forEach(function (btn) {
      var isActive = btn.getAttribute('data-tab') === name;
      btn.classList.toggle('active', isActive);
    });
    // Update panels
    document.querySelectorAll('[data-tab-panel]').forEach(function (panel) {
      var isActive = panel.getAttribute('data-tab-panel') === name;
      panel.classList.toggle('active', isActive);
    });
  }

  // Tab buttons in the [data-tabs] container
  container.querySelectorAll('.auth-tab').forEach(function (btn) {
    btn.addEventListener('click', function () {
      activateTab(btn.getAttribute('data-tab'));
    });
  });

  // Any button/link elsewhere that carries [data-tab]
  document.addEventListener('click', function (e) {
    var trigger = e.target.closest('[data-tab]');
    if (!trigger || trigger.classList.contains('auth-tab')) return;
    activateTab(trigger.getAttribute('data-tab'));
  });

  // Auto-open recover panel if URL contains ?recover
  if (window.location.search.indexOf('recover') !== -1) {
    activateTab('recover');
  }
})();

// ── Product Carousel (CSS-Animation + Prev/Next) ───────────────
(function () {
  'use strict';

  document.querySelectorAll('.carousel-wrap').forEach(function (wrap) {
    var track = wrap.querySelector('.carousel-track');
    var prevBtn = wrap.querySelector('[data-carousel-prev]');
    var nextBtn = wrap.querySelector('[data-carousel-next]');
    if (!track) return;

    var DURATION = 40; // seconds — matches CSS animation duration
    var paused = false;

    // Die Marquee-Klone doppeln jedes Produkt im Accessibility-Baum —
    // ein Screenreader liest die Schiene sonst zweimal vor. aria-hidden
    // allein waere falsch, weil die Klone sichtbar und klickbar sind:
    // ein Tastaturnutzer landete auf nicht angekuendigten Elementen.
    // Deshalb zusaetzlich aus der Tab-Reihenfolge nehmen — die Originale
    // decken jedes Produkt bereits ab. Beides zusammen oder gar nicht.
    var clones = track.querySelector('.carousel-clones');
    if (clones) {
      clones.querySelectorAll('a[href], button, input, select, textarea').forEach(function (el) {
        el.setAttribute('tabindex', '-1');
      });
      clones.setAttribute('aria-hidden', 'true');
    }

    function getProgress() {
      var transform = window.getComputedStyle(track).transform;
      if (!transform || transform === 'none') return 0;

      var tx = NaN;
      if (typeof DOMMatrix === 'function') {
        try { tx = new DOMMatrix(transform).m41; } catch (e) { tx = NaN; }
      }
      if (isNaN(tx)) {
        // Fallback: bei matrix() liegt tx an Index 4, bei matrix3d() an 12.
        var vals = transform.match(/matrix(3d)?\(([^)]+)\)/);
        if (!vals) return 0;
        var parts = vals[2].split(',');
        tx = parseFloat(parts[vals[1] ? 12 : 4]);
      }
      if (isNaN(tx)) return 0;

      var half = track.scrollWidth / 2;
      return half > 0 ? Math.min(1, Math.abs(tx) / half) : 0;
    }

    function shiftBy(delta) {
      var progress = getProgress();
      var newProgress = Math.max(0, Math.min(0.999, progress + delta));
      var newDelay = -(newProgress * DURATION);
      track.style.animationDelay = newDelay + 's';
      // Wer bewusst pausiert hat, bleibt pausiert — sonst haette der
      // Timeout unten die Pause nach 600ms wieder aufgehoben.
      if (paused) return;
      track.style.animationPlayState = 'paused';
      setTimeout(function () {
        if (!paused) track.style.animationPlayState = '';
      }, 600);
    }

    if (prevBtn) prevBtn.addEventListener('click', function () { shiftBy(-0.05); });
    if (nextBtn) nextBtn.addEventListener('click', function () { shiftBy(0.05); });

    // Der Pause-Button sitzt im Section-Header, nicht in .carousel-wrap.
    var scope = wrap.closest('.bestseller-section');
    var pauseBtn = scope ? scope.querySelector('[data-carousel-pause]') : null;
    if (pauseBtn) {
      pauseBtn.addEventListener('click', function () {
        paused = !paused;
        pauseBtn.setAttribute('aria-pressed', String(paused));
        // Leerer String gibt die Kontrolle an CSS zurueck, damit
        // :hover und :focus-within weiter greifen.
        track.style.animationPlayState = paused ? 'paused' : '';
      });
    }
  });
})();

// ── Hero-Hintergrundvideo: erst ab Desktop einhaengen ──────────
(function () {
  'use strict';

  var tpl = document.querySelector('[data-hero-video]');
  if (!tpl || !tpl.content) return;

  var wide = window.matchMedia('(min-width: 769px)');
  var still = window.matchMedia('(prefers-reduced-motion: reduce)');
  var mounted = false;

  function mount() {
    if (mounted || !wide.matches || still.matches) return;
    mounted = true;
    tpl.parentNode.insertBefore(tpl.content.cloneNode(true), tpl);
    wide.removeEventListener('change', mount);
  }

  mount();
  // Nachladen, wenn erst spaeter ins Desktop-Layout gewechselt wird
  // (Geraet gedreht, Fenster aufgezogen).
  if (!mounted) wide.addEventListener('change', mount);
})();

// ── Collection: Kategorien klappen, Filter ohne Seitenneuladen ──
(function () {
  'use strict';

  var root = document.querySelector('[data-collection-root]');
  if (!root) return;

  var sectionId = root.getAttribute('data-section-id');

  // ── Unterkategorien auf-/zuklappen ───────────────────────────
  // Ohne JS stehen alle Unterlisten offen; hier werden die
  // eingeklappt, die nicht zur aktiven Kategorie gehoeren.
  root.querySelectorAll('[data-subnav-toggle]').forEach(function (btn) {
    var sub = document.getElementById(btn.getAttribute('aria-controls'));
    if (!sub) return;
    if (btn.getAttribute('aria-expanded') !== 'true') sub.hidden = true;

    btn.addEventListener('click', function () {
      var open = btn.getAttribute('aria-expanded') === 'true';
      btn.setAttribute('aria-expanded', String(!open));
      sub.hidden = open;
      var arrow = btn.querySelector('.sidebar-nav-arrow');
      if (arrow) arrow.classList.toggle('open', !open);
    });
  });

  // ── Filtergruppen auf-/zuklappen ─────────────────────────────
  // Das CSS dafuer (.filter-group.collapsed) war vorhanden, der
  // Handler fehlte — die Titel waren nicht klickbar.
  root.querySelectorAll('[data-toggle="filter"]').forEach(function (btn) {
    btn.addEventListener('click', function () {
      var group = btn.closest('.filter-group');
      if (!group) return;
      var collapsed = group.classList.toggle('collapsed');
      btn.setAttribute('aria-expanded', String(!collapsed));
    });
  });

  // ── Filter, Sortierung und Blaettern per fetch ────────────────
  // Vorher submittete jede Checkbox das Formular: kompletter
  // Seitenaufbau, Scrollposition zurueck auf Anfang. Jetzt wird nur
  // die Section neu gerendert (Section Rendering API) und gezielt
  // ausgetauscht — die Kategorien-Navigation bleibt unberuehrt,
  // damit aufgeklappte Zweige offen bleiben.
  var busy = false;

  // swap() ersetzt das Filterformular durch einen frischen Knoten. Eine
  // gemerkte Referenz zeigt danach auf ein entferntes Element: FormData
  // laese dann Zustaende von vor dem Austausch, und Felder, die per
  // form-Attribut von aussen dazugehoeren, gar nicht mehr. Deshalb bei
  // jedem Aufruf frisch holen.
  function currentForm() {
    return root.querySelector('#collection-filter-form');
  }

  function buildQuery() {
    var params = new URLSearchParams();
    var form = currentForm();
    if (form) {
      new FormData(form).forEach(function (value, key) {
        if (String(value).length) params.append(key, value);
      });
    }
    var sort = root.querySelector('[data-sort-select]');
    if (sort && sort.value) params.set('sort_by', sort.value);
    return params;
  }

  function swap(fresh, selector) {
    var next = fresh.querySelector(selector);
    var current = root.querySelector(selector);
    if (next && current) current.replaceWith(next);
  }

  async function load(url, opts) {
    if (busy) return;
    busy = true;
    root.setAttribute('aria-busy', 'true');
    root.classList.add('is-loading');

    try {
      var target = new URL(url, window.location.origin);
      target.searchParams.set('section_id', sectionId);

      var res = await fetch(target.toString());
      if (!res.ok) throw new Error('HTTP ' + res.status);
      var fresh = new DOMParser().parseFromString(await res.text(), 'text/html');

      // Welche Filtergruppen waren zugeklappt? Nach dem Austausch
      // denselben Zustand wiederherstellen.
      var collapsed = [];
      root.querySelectorAll('.filter-group').forEach(function (g, i) {
        if (g.classList.contains('collapsed')) collapsed.push(i);
      });

      swap(fresh, 'main');
      swap(fresh, '#collection-filter-form');
      swap(fresh, '.filter-head');
      swap(fresh, '.collection-toolbar');

      root.querySelectorAll('.filter-group').forEach(function (g, i) {
        if (collapsed.indexOf(i) !== -1) {
          g.classList.add('collapsed');
          var t = g.querySelector('[data-toggle="filter"]');
          if (t) t.setAttribute('aria-expanded', 'false');
        }
      });

      var shown = url.replace(/([?&])section_id=[^&]*/g, '$1').replace(/[?&]$/, '');
      window.history.pushState({}, '', shown);

      if (opts && opts.scrollTo) {
        var anchor = root.querySelector('main');
        if (anchor) anchor.scrollIntoView({ behavior: 'smooth', block: 'start' });
      }
    } catch (e) {
      // Im Fehlerfall normal navigieren, damit der Filter trotzdem greift.
      window.location.href = url;
      return;
    } finally {
      busy = false;
      root.removeAttribute('aria-busy');
      root.classList.remove('is-loading');
    }
  }

  function apply(opts) {
    var q = buildQuery().toString();
    load(window.location.pathname + (q ? '?' + q : ''), opts);
  }

  // Alle Bedienelemente haengen an root, nicht an den Formularen selbst:
  // die werden ausgetauscht, root bleibt. Direkt registrierte Handler waeren
  // nach dem ersten Filtern verschwunden.
  root.addEventListener('submit', function (e) {
    if (e.target.matches('#collection-filter-form, [data-sort-form]')) {
      e.preventDefault();
      apply();
    }
  });

  root.addEventListener('change', function (e) {
    // Die Seitengroesse wechselt das Template: ?view=48 laedt
    // collection.48.json. Ob die Section Rendering API einem solchen Wechsel
    // folgt, sichert Shopify nirgends zu — ein Teil-Austausch koennte die
    // alte Groesse zurueckliefern, waehrend die URL schon die neue behauptet.
    // Deshalb hier bewusst ein normaler Seitenaufruf. buildQuery() nimmt
    // Filter und Sortierung mit; der Select haengt per form-Attribut am
    // Filterformular.
    if (e.target.matches('[data-view-select]')) {
      window.location.assign(window.location.pathname + '?' + buildQuery().toString());
      return;
    }
    if (e.target.matches('[data-sort-select]')) {
      apply();
      return;
    }
    // Kaestchen und Preisfelder des Filterformulars
    if (e.target.closest('#collection-filter-form')
        && e.target.matches('input[type="checkbox"], input[type="number"]')) {
      apply();
    }
  });

  // Blaettern: an den Listenanfang scrollen statt an den Seitenkopf
  root.addEventListener('click', function (e) {
    var link = e.target.closest('.pagination a, .page-btn, .page-num');
    if (!link || !link.href) return;
    e.preventDefault();
    load(link.getAttribute('href'), { scrollTo: true });
  });

  // Zurueck-Button im Browser bedienen
  window.addEventListener('popstate', function () {
    load(window.location.pathname + window.location.search);
  });
})();

// ── Mega-Panel: kurze Gnadenzeit beim Verlassen ────────────────
(function () {
  'use strict';

  // Zwischen Menuepunkt und Panel liegt eine Luecke. Rein per :hover
  // klappt nur der senkrechte Weg — faehrt die Maus diagonal, verlaesst
  // sie den schmalen Menuepunkt seitlich, bevor sie das breite Panel
  // erreicht, und das Panel schliesst. Ein Pseudo-Element als Bruecke
  // hilft nicht: es erbt visibility und ist im selben Moment weg.
  // Deshalb wird das Schliessen kurz verzoegert.
  var GRACE = 220;

  document.querySelectorAll('.nav-item.has-mega').forEach(function (item) {
    var timer = null;

    function open() {
      clearTimeout(timer);
      item.classList.add('is-open');
    }
    function close() {
      clearTimeout(timer);
      timer = setTimeout(function () { item.classList.remove('is-open'); }, GRACE);
    }

    // mouseleave feuert erst, wenn auch das Panel verlassen ist —
    // ein Wiedereintritt innerhalb der Gnadenzeit bricht das Schliessen ab.
    item.addEventListener('mouseenter', open);
    item.addEventListener('mouseleave', close);

    // Escape schliesst, wie bei Dropdowns erwartet
    item.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') {
        clearTimeout(timer);
        item.classList.remove('is-open');
        var trigger = item.querySelector('.nav-parent');
        if (trigger) trigger.focus();
      }
    });

    // Das Panel scrollt selbst und schneidet dabei alles ab, was ueber
    // seinen Rand ragt. Ein Modell-Flyout, das unten oder rechts
    // hinausliefe, klappt deshalb nach oben bzw. links auf.
    var panel = item.querySelector('.nav-mega');
    if (!panel) return;
    item.querySelectorAll('.nav-mega-list > li').forEach(function (li) {
      var sub = li.querySelector(':scope > .nav-mega-sublist');
      if (!sub) return;
      function place() {
        sub.classList.remove('opens-up', 'opens-left');
        var p = panel.getBoundingClientRect();
        var s = sub.getBoundingClientRect();
        var l = li.getBoundingClientRect();
        if (!s.height) return;   // Flyout noch nicht sichtbar
        if (s.bottom > p.bottom - 8 && l.top - p.top > s.height + 8) sub.classList.add('opens-up');
        if (s.right > p.right - 8) sub.classList.add('opens-left');
      }
      li.addEventListener('mouseenter', place);
      li.addEventListener('focusin', place);
    });
  });
})();

// ── Suche: Seitengroesse abschicken ────────────────────────────
// Das Formular ist ein echtes GET-Formular und kaeme auch ohne diese Zeilen
// aus — der noscript-Knopf traegt den Fall. Hier entfaellt nur der Klick.
(function () {
  'use strict';

  var form = document.querySelector('[data-view-form]');
  if (!form) return;

  form.addEventListener('change', function (e) {
    if (e.target.matches('[data-view-select]')) form.submit();
  });
})();

// ── Merkliste ──────────────────────────────────────────────────
// Die Knoepfe mit data-wishlist-toggle standen im Markup, ohne dass irgendwo
// Code dazu existierte — Klicken tat nichts. Gemerkt werden Produkt-Handles
// im Browser des Besuchers; das braucht kein Konto und keinen Serverzustand.
(function () {
  'use strict';

  var KEY = 'gng_wishlist';

  function read() {
    try {
      var raw = window.localStorage.getItem(KEY);
      if (!raw) return [];
      var list = JSON.parse(raw);
      return Array.isArray(list) ? list.filter(function (h) { return typeof h === 'string' && h; }) : [];
    } catch (e) {
      return []; // privater Modus, gesperrter Speicher oder kaputter Inhalt
    }
  }

  function write(list) {
    try {
      window.localStorage.setItem(KEY, JSON.stringify(list));
      return true;
    } catch (e) {
      return false;
    }
  }

  function has(handle) {
    return read().indexOf(handle) !== -1;
  }

  function toggle(handle) {
    var list = read();
    var at = list.indexOf(handle);
    if (at === -1) list.push(handle);
    else list.splice(at, 1);
    write(list);
    return at === -1;
  }

  // Nach aussen sichtbar, damit die Merklisten-Seite denselben Speicher nutzt
  // statt einen zweiten daneben aufzubauen.
  window.gngWishlist = {
    all: read,
    has: has,
    toggle: toggle,
    // Nachtraeglich eingefuegte Karten (Merklisten-Seite) tragen noch keinen
    // Zustand — danach muss der Anstrich wiederholt werden.
    refresh: function () { paintAll(); },
    remove: function (handle) {
      var list = read().filter(function (h) { return h !== handle; });
      write(list);
      paintAll();
      return list;
    },
  };

  function paint(btn) {
    var handle = btn.dataset.wishlistToggle;
    if (!handle) return;
    var on = has(handle);
    btn.classList.toggle('active', on);
    btn.setAttribute('aria-pressed', String(on));

    // Auf der Produktseite traegt der Knopf einen Text, auf der Karte nicht.
    var label = btn.querySelector('[data-wishlist-label]');
    if (label) {
      var next = on ? btn.dataset.labelRemove : btn.dataset.labelAdd;
      if (next) label.textContent = next;
    } else if (btn.dataset.labelAdd) {
      btn.setAttribute('aria-label', on ? btn.dataset.labelRemove : btn.dataset.labelAdd);
    }
  }

  function paintAll() {
    Array.prototype.forEach.call(document.querySelectorAll('[data-wishlist-toggle]'), paint);
    var count = read().length;
    Array.prototype.forEach.call(document.querySelectorAll('[data-wishlist-count]'), function (el) {
      el.textContent = count ? String(count) : '';
      el.hidden = count === 0;
    });
  }

  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-wishlist-toggle]');
    if (!btn) return;
    e.preventDefault();
    toggle(btn.dataset.wishlistToggle);
    paintAll();
  });

  paintAll();

  // Zwei offene Tabs sollen sich nicht widersprechen.
  window.addEventListener('storage', function (e) {
    if (e.key === KEY) paintAll();
  });
})();

// ── Konto-Menü in der Kopfzeile ────────────────────────────────
// <details> bringt Aufklappen und Tastaturbedienung selbst mit; was fehlt,
// ist das Schliessen bei einem Klick daneben und mit Escape.
(function () {
  'use strict';

  var menu = document.querySelector('[data-account-menu]');
  if (!menu) return;

  document.addEventListener('click', function (e) {
    if (menu.open && !menu.contains(e.target)) menu.open = false;
  });

  document.addEventListener('keydown', function (e) {
    if (e.key !== 'Escape' || !menu.open) return;
    menu.open = false;
    var trigger = menu.querySelector('summary');
    if (trigger) trigger.focus();
  });
})();

// ── Suche: Live-Vorschläge ─────────────────────────────────────
// Lädt beim Tippen die Section "predictive-search" (Shopify Section
// Rendering) in die Liste unter dem Suchfeld. Ohne JavaScript bleibt das
// Feld ein normales Suchformular.
(function () {
  'use strict';

  var MIN_CHARS = 2;
  var DELAY_MS = 250;
  var SECTION_ID = 'predictive-search';

  document.querySelectorAll('[data-predictive-search]').forEach(setupSearch);

  function setupSearch(form) {
    var input = form.querySelector('[data-predictive-input]');
    var results = form.querySelector('[data-predictive-results]');
    if (!input || !results) return;

    var cache = {};
    var timer = null;
    var controller = null;
    var activeIndex = -1;

    input.addEventListener('input', function () {
      clearTimeout(timer);
      var terms = input.value.trim();
      if (terms.length < MIN_CHARS) {
        close();
        return;
      }
      timer = setTimeout(function () { load(terms); }, DELAY_MS);
    });

    input.addEventListener('focus', function () {
      if (results.innerHTML.trim() && input.value.trim().length >= MIN_CHARS) open();
    });

    input.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && !results.hidden) {
        e.preventDefault();
        close();
        return;
      }
      if (e.key === 'Tab') {
        close();
        return;
      }
      if (results.hidden) return;
      if (e.key === 'ArrowDown' || e.key === 'ArrowUp') {
        e.preventDefault();
        move(e.key === 'ArrowDown' ? 1 : -1);
      } else if (e.key === 'Enter' && activeIndex > -1) {
        var link = getOptions()[activeIndex].querySelector('a');
        if (link) {
          e.preventDefault();
          window.location.href = link.href;
        }
      }
    });

    // Kein focusout: iOS fokussiert angetippte Links nicht, die Liste wuerde
    // sonst vor dem Klick auf einen Vorschlag verschwinden.
    document.addEventListener('click', function (e) {
      if (!form.contains(e.target)) close();
    });

    function load(terms) {
      if (Object.prototype.hasOwnProperty.call(cache, terms)) {
        render(cache[terms]);
        return;
      }
      if (controller) controller.abort();
      controller = new AbortController();

      var url = form.dataset.suggestUrl +
        '?q=' + encodeURIComponent(terms) +
        '&resources[type]=product,collection' +
        '&resources[limit]=6' +
        '&resources[limit_scope]=each' +
        '&resources[options][unavailable_products]=last' +
        '&section_id=' + SECTION_ID;

      fetch(url, { signal: controller.signal })
        .then(function (response) {
          if (!response.ok) throw new Error('Suggest request failed: ' + response.status);
          return response.text();
        })
        .then(function (html) {
          var doc = new DOMParser().parseFromString(html, 'text/html');
          var section = doc.getElementById('shopify-section-' + SECTION_ID);
          var markup = section ? section.innerHTML.trim() : '';
          cache[terms] = markup;
          // The user may have typed on while the request was running.
          if (input.value.trim() === terms) render(markup);
        })
        .catch(function (error) {
          if (error.name === 'AbortError') return;
          // Suggestions are a convenience: on failure the form still submits.
          close();
        });
    }

    function render(markup) {
      results.innerHTML = markup;
      activeIndex = -1;
      markActive();
      if (markup) open(); else close();
    }

    function open() {
      results.hidden = false;
      input.setAttribute('aria-expanded', 'true');
    }

    function close() {
      results.hidden = true;
      input.setAttribute('aria-expanded', 'false');
      activeIndex = -1;
      markActive();
    }

    function getOptions() {
      return Array.prototype.slice.call(results.querySelectorAll('.ps-option'));
    }

    function move(step) {
      var options = getOptions();
      if (!options.length) return;
      activeIndex = (activeIndex + step + options.length) % options.length;
      markActive();
    }

    function markActive() {
      input.removeAttribute('aria-activedescendant');
      getOptions().forEach(function (option, index) {
        var isActive = index === activeIndex;
        option.setAttribute('aria-selected', String(isActive));
        option.classList.toggle('is-active', isActive);
        if (isActive) {
          input.setAttribute('aria-activedescendant', option.id);
          option.scrollIntoView({ block: 'nearest' });
        }
      });
    }
  }
})();
